var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPurchaseStarted(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 15,
    viewBox: "0 0 13 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8125 3.51562H9.42188V3.23438C9.42188 1.44844 7.97344 0 6.1875 0C4.40156 0 2.95312 1.44844 2.95312 3.23438V3.51562H0.5625C0.251367 3.51562 0 3.76699 0 4.07812V13.5C0 13.8111 0.251367 14.0625 0.5625 14.0625H11.8125C12.1236 14.0625 12.375 13.8111 12.375 13.5V4.07812C12.375 3.76699 12.1236 3.51562 11.8125 3.51562ZM8.15625 3.51562H4.21875V3.23438C4.21875 2.14629 5.09941 1.26562 6.1875 1.26562C7.27559 1.26562 8.15625 2.14629 8.15625 3.23438V3.51562Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurchaseStarted);
export default __webpack_public_path__ + "static/media/purchase-started.d596c95bc1686083c2a593fafabd2a31.svg";
export { ForwardRef as ReactComponent };